import LightStyles from './light';
import DarkStyles from './dark';
import { css } from 'styled-components';

const AutoTheme = css`
  ${LightStyles}
  @media (prefers-color-scheme: dark) {
    ${({ themeMode }) => themeMode === 'auto' && DarkStyles}
  }

  @media (prefers-color-scheme: light) {
    ${({ themeMode }) => themeMode === 'auto' && LightStyles}
  }

  ${({ themeMode }) => themeMode === 'dark' && DarkStyles}
  ${({ themeMode }) => themeMode === 'light' && LightStyles}
  ${({ enableDarkMode }) => enableDarkMode === true && DarkStyles}

`;

export default AutoTheme;
